import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLink, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { HelperService } from '../../services/helper.service';
import { HttpService } from '../../services/http.service';
import { FormBuilder, Validators } from '@angular/forms';
import { distinctUntilChanged, finalize, Subject, takeUntil } from 'rxjs';
import { LoaderService } from '../../services/loader.service';
import { Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';
import { ModalComponent } from '../modals/modal/modal.component';

@Component({
  selector: 'app-add-creator-info',
  standalone: true,
  imports: [InputComponent, FontAwesomeModule, ModalComponent],
  templateUrl: './add-creator-info.component.html',
  styleUrl: './add-creator-info.component.scss',
})
export class AddCreatorInfoComponent {
  faTimes = faTimes;
  faUser = faUser;
  faLink = faLink;
  creatorInfo: boolean = false;
  public InfoForm: any = this.fb.group({
    creatorName: [
      null,
      [Validators.required, Validators.pattern('^[a-zA-Z s]*$')],
    ],
    socialLink: [
      null,
      [
        Validators.required,
        Validators.pattern(
          '^(https?://)?([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}(\\S*)?$',
        ),
      ],
    ],
  });
  private destroy$ = new Subject<void>();

  constructor(
    public helper: HelperService,
    private _router: Router,
    private http: HttpService,
    private fb: FormBuilder,
    private modalService: ModalService,
  ) {
    this.modalService
      .getModalStateObservable()
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((state: any) => {
        this[state?.id] = state?.show;
      });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  addCreator() {
    this.http
      .loaderPost(
        'api/Home/tell-us-about-creator',
        this.InfoForm.value,
        false,
        true,
      )
      .pipe(
        finalize(() => {
          LoaderService.loader.next(false);
        }),
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((response: any) => {
        this.helper.showModal(false, 'creatorInfo');
        this._router.navigateByUrl(
          '/creators/' + localStorage.getItem('collectionRedirectPath'),
        );
      });
  }
}
